<template>
  <div>
    <ts-loading-banner :loading="loading">
      <gmap-map :center="center" :zoom="13" style="width:100%;  height: 100vh;">
        <gmap-polygon
          v-if="!loading"
          :paths="paths"
          :options="{
            fillColor: 'red',
            strokeWeight: 1.0,
            strokeColor: 'red'
          }"
        ></gmap-polygon>
        <gmap-polyline 
          v-if="check_in_mark && check_out_mark" 
          :path="plPath" 
          :options="{geodesic:true, strokeColor:'#FF0000'}"
        >
        </gmap-polyline>
        <gmap-marker
          v-if="check_in_mark"
          title="Check-in"
          :position="check_in_mark"
          :icon="{url: 'http://maps.google.com/mapfiles/ms/icons/green-dot.png'}"
        >
        </gmap-marker>
        <gmap-marker
          title="Check-out"
          :position="check_out_mark"
        >
        </gmap-marker>
      </gmap-map>
    </ts-loading-banner>
  </div>
</template>

<script>
import PageOptions from '@/config/PageOptions.vue'
import { mapActions } from 'vuex'

export default {
  name: 'GoogleMap',
  data() {
    return {
      loading: false,
      center: { lng: 105.57359185298843, lat: 12.291513194851614 },
      paths: [],
      plPath: [],
      check_in_mark: null,
      check_out_mark: null
    }
  },
  created() {
    this.fetchData()
  },
  methods: {
    ...mapActions('customer/locationVisitation', ['viewMap']),
    fetchData() {
      this.loading = true
      this.viewMap({
        commune_code: this.$route.params.commune_code,
        plan_id: this.$route.params.plan_id
      })
        .then(response => {
          var data = response.data
          this.paths = data.paths
          this.center.lat = data.paths[0][0].lat
          this.center.lng = data.paths[0][0].lng

          this.check_in_mark = data.check_in_coordinate.lat ? data.check_in_coordinate : null
          this.check_out_mark = data.check_out_coordinate.lat ? data.check_out_coordinate : null

          this.plPath = [
            this.check_in_mark,
            this.check_out_mark
          ]

        })
        .finally(() => {
          this.loading = false
        })
    }
  },
  beforeRouteEnter(to, from, next) {
    PageOptions.pageEmpty = true
    next()
  }
}
</script>
